import React from "react";
import { Icon, IconButton } from "@chakra-ui/react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { ff } from "theme";
import { HEART_RED } from "./MessageHeartBadge";

interface MessageHeartButtonProps {
  hearted: boolean;
  onToggle: () => void;
}

/**
 * Heart toggle beside a brand bubble, for mouse users: it shows on hover of the row (which must
 * carry `role="group"`). Touch screens have no hover, so it is not rendered there at all —
 * double-tapping the bubble does the same job.
 */
const MessageHeartButton: React.FC<MessageHeartButtonProps> = ({ hearted, onToggle }) => (
  <IconButton
    aria-label={hearted ? "Remove heart" : "Love message"}
    icon={<Icon as={hearted ? FaHeart : FaRegHeart} boxSize="14px" color={hearted ? HEART_RED : ff.muted} />}
    variant="ghost"
    size="xs"
    borderRadius="full"
    // Level with the bubble's first line: centred on the whole column it sank toward the
    // timestamp, and dropped further once a heart badge made the column taller.
    alignSelf="flex-start"
    mt="8px"
    ml="4px"
    flexShrink={0}
    display="none"
    opacity={0}
    transition="opacity 0.12s"
    _groupHover={{ opacity: 1 }}
    _focusVisible={{ opacity: 1 }}
    sx={{ "@media (hover: hover)": { display: "inline-flex" } }}
    onClick={onToggle}
  />
);

export default MessageHeartButton;
